export default function HeroSection() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/e612743e6b246cab232945fdd656dee0.jpg)',
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 text-center pt-24 md:pt-32">
        <div className="mb-8 md:mb-12">
          <h1 className="text-3xl md:text-7xl font-bold text-white mb-3 md:mb-4 leading-tight">
            飲食の未来を
          </h1>
          <h1 className="text-3xl md:text-7xl font-bold text-white mb-4 md:mb-6 leading-tight">
            デザインする
          </h1>
          <p className="text-lg md:text-3xl text-amber-200 font-light italic">
            経営パートナー
          </p>
        </div>

        <p className="text-sm md:text-xl text-gray-200 mb-8 md:mb-12 max-w-3xl mx-auto leading-relaxed px-2">
          味噌ラーメン専門店「花木流味噌 五反野店」の運営で培った実践的なノウハウと、
          経営コンサルティングの専門知識で、あなたのビジネスを支援します
        </p>

        <div className="flex flex-col sm:flex-row gap-3 md:gap-6 justify-center items-center">
          <button
            onClick={() => scrollToSection('restaurants')}
            className="w-full sm:w-auto bg-teal-700 text-white px-6 md:px-8 py-3 md:py-4 rounded-full text-sm md:text-base font-medium hover:bg-teal-800 transition-all flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer"
          >
            花木流味噌 五反野店について
            <i className="ri-arrow-right-line"></i>
          </button>
          <button
            onClick={() => scrollToSection('consulting')}
            className="w-full sm:w-auto border-2 border-white text-white px-6 md:px-8 py-3 md:py-4 rounded-full text-sm md:text-base font-medium hover:bg-white hover:text-teal-700 transition-all flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer"
          >
            コンサルティング相談
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>

        {/* Desktop only card grid */}
        <div className="hidden md:grid mt-20 grid-cols-3 gap-8 max-w-5xl mx-auto">
          <div className="relative group">
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl overflow-hidden transform transition-all duration-300 hover:scale-105">
              <div className="h-64 w-full">
                <img
                  src="https://readdy.ai/api/search-image?query=exquisite%20japanese%20kaiseki%20cuisine%20beautifully%20plated%20on%20traditional%20ceramic%20dish%20with%20seasonal%20ingredients%20artistic%20presentation%20and%20elegant%20composition%20featuring%20fresh%20sashimi%20delicate%20garnishes%20in%20soft%20natural%20lighting%20with%20clean%20white%20background&width=400&height=500&seq=dish001&orientation=portrait"
                  alt="日本料理"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
          <div className="relative group md:mt-8">
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl overflow-hidden transform transition-all duration-300 hover:scale-105">
              <div className="h-80 w-full">
                <img
                  src="https://readdy.ai/api/search-image?query=sophisticated%20japanese%20restaurant%20interior%20design%20with%20warm%20ambient%20lighting%20traditional%20wooden%20architecture%20modern%20minimalist%20aesthetic%20featuring%20elegant%20dining%20space%20with%20natural%20materials%20and%20zen%20atmosphere%20in%20professional%20photography%20style&width=400&height=600&seq=interior001&orientation=portrait"
                  alt="店内の雰囲気"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
          <div className="relative group">
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl overflow-hidden transform transition-all duration-300 hover:scale-105">
              <div className="h-64 w-full">
                <img
                  src="https://readdy.ai/api/search-image?query=professional%20business%20consulting%20meeting%20in%20modern%20office%20with%20japanese%20businesspeople%20discussing%20restaurant%20management%20strategy%20featuring%20laptops%20documents%20and%20collaborative%20atmosphere%20in%20bright%20natural%20lighting%20with%20clean%20background&width=400&height=500&seq=consulting001&orientation=portrait"
                  alt="コンサルティング"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
